"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const context_1 = require("../../../../context");
exports.UserNavItem = () => {
    const { currentUser: { fullName, email }, loadApp, } = react_1.useContext(context_1.OsmosysAppContext);
    return (react_1.default.createElement(reactstrap_1.NavItem, null,
        react_1.default.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, to: "/profile", className: classnames_1.default({
                'text-dark': !loadApp.loading,
            }) },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: loadApp.loading ? pro_solid_svg_icons_1.faSpinnerThird : pro_solid_svg_icons_1.faUserCircle, 
                // style={{
                //   opacity: !loadApp.loading && userIsIdle ? 0.7 : 1,
                // }}
                spin: !!loadApp.loading, className: classnames_1.default('mr-md-2 fa-opacity-transition', {
                    'text-primary': loadApp.loading,
                }) }),
            react_1.default.createElement("span", { className: classnames_1.default({
                    'text-dark': !!loadApp.loading,
                }, 'd-none d-md-inline'), "data-name": "app-nav-user-display-name" }, fullName || email))));
};
//# sourceMappingURL=UserNavItem.js.map